import { writable } from 'svelte/store';
import GameState from './model/gamestate';
export const gamestate = writable(new GameState());
